import { useEffect } from "react"
import { toast } from "@stardust-ds/react"
import intl from "react-intl-universal"

import { listSectors, createSector } from "../../../../../services/ciq"
import MultiSelect from "../MultiSelect"
import useDataApi from "../../../../../hooks/useDataApi"

export const SectorSelect = (props) => {
  const { ...oRest } = props

  const [oListSectorRes, fnListSectorReq] = useDataApi(listSectors)
  const [oCreateSectorRes, fnCreateSectorReq] = useDataApi(createSector)

  useEffect(() => {
    if (oListSectorRes.loading || oListSectorRes.done) return
    
    fnListSectorReq()
  }, [oListSectorRes])

  useEffect(() => {
    if (oCreateSectorRes.loading || !oCreateSectorRes.done) return
    if (oCreateSectorRes.data) {
      toast({
        type: "success",
        title: intl.get("ciq.sector.created_success"),
      })
      fnListSectorReq()

      return
    }

    if (oCreateSectorRes.error) {
      const cErrorMessage = oCreateSectorRes.error?.response?.data?.message || null
      toast({
        type: "error",
        title: intl.get("ciq.sector.created_error"),
        description: cErrorMessage,
      })
    }
  }, [oCreateSectorRes])

  const postSector = async (sector_name) => {
    return await fnCreateSectorReq({ sector_cname: sector_name })
  }

  const optsSector = oListSectorRes?.data?.data?.length
    ? oListSectorRes?.data?.data?.map((item) => ({
        ...item,
        label: item?.sector_cname,
        value: item?.sector_cname,
        id: item.sector_nid,
      }))
    : []

  return (
    <MultiSelect
      limitOptsSelected={1}
      opts={optsSector}
      onCreateOption={postSector}
      isloading={oListSectorRes.loading || oCreateSectorRes.loading}
      type="sector"
      {...oRest}
    />
  )
}
